import {type Environment, commitMutation, graphql} from 'react-relay'
import type {
  createLinkedBranchMutation,
  createLinkedBranchMutation$data,
} from './__generated__/createLinkedBranchMutation.graphql'

export function commitCreateLinkedBranchMutation({
  environment,
  input: {repositoryId, branchName, oid, issueId},
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {repositoryId: string; branchName: string; oid: string; issueId: string}
  onError?: (error: Error) => void
  onCompleted?: (response: createLinkedBranchMutation$data) => void
}) {
  return commitMutation<createLinkedBranchMutation>(environment, {
    mutation: graphql`
      mutation createLinkedBranchMutation($input: CreateLinkedBranchInput!) @raw_response_type {
        createLinkedBranch(input: $input) {
          linkedBranch {
            ref {
              id
              name
              prefix
            }
          }
          issue {
            ... on Issue {
              linkedBranches(first: 25) {
                edges {
                  node {
                    id
                    ref {
                      ...BranchPickerRef
                    }
                  }
                }
              }
              repository {
                refs(refPrefix: "refs/heads/", first: 25) {
                  edges {
                    node {
                      ...BranchPickerRef
                    }
                  }
                }
              }
            }
          }
          clientMutationId
        }
      }
    `,
    variables: {input: {repositoryId, name: branchName, oid, issueId}},
    onError: error => onError?.(error),
    onCompleted: response => {
      if (!response.createLinkedBranch?.linkedBranch) {
        onError?.({name: 'LinkedBranchNotFound', message: 'Linked branch not found'})
      } else {
        onCompleted?.(response)
      }
    },
  })
}
